import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    officeCode: '',
}

const officeCodeSlice = createSlice({
    name: 'officeCodeSlice',
    initialState: initialState,
    reducers: {
        updateOC(state, action) {
            state.officeCode = action.payload.officeCode;
        },
        resetState(state) {
            state.officeCode = 15
        },
    },
});

export const { updateOC, resetState } = officeCodeSlice.actions;

export default officeCodeSlice.reducer;
